<template>
  <v-dialog v-model="dialog" max-width="300" persistent>
    <v-card class="pa-0">
      <!-- Header / Toolbar -->
      <v-toolbar dense flat color="red-darken-3" theme="dark">
        <v-spacer />
        <v-btn icon @click="dialog = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>

      <!-- QR Code -->
      <div class="d-flex flex-column align-center justify-center pa-o ma-0">
        <qr-code v-if="id" :size="300" :text="id" />

        <!-- ID + Print -->
        <v-row align="center" justify="center" class="mt-3 mb-2" no-gutters>
          <v-col cols="9" class="text-center">
            <h2 class="mb-0 text-black">
              {{ slicedId }}
            </h2>
          </v-col>
          <v-col cols="3" class="text-right">
            <v-tooltip bottom>
              <template #activator="{ on, attrs }">
                <v-btn
                  v-bind="attrs"
                  icon
                  variant="text"
                  :loading="loading"
                  v-on="on"
                  @click="print"
                >
                  <v-icon color="black">
                    {{ printed ? "mdi-printer-off" : "mdi-printer" }}
                  </v-icon>
                </v-btn>
              </template>
              <span v-if="printed">
                <v-row align="center" no-gutters>
                  <v-icon small class="mr-1">mdi-printer-off</v-icon>
                  {{ $t("printed_alert") }}
                </v-row>
              </span>
            </v-tooltip>
          </v-col>
        </v-row>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import VueQrCode from "vue-qr-generator"; // eslint-disable-line import/extensions
import QrCode from "qrcode";
import { Printd } from "printd";
import getRequest from "../api/getRequest";
import postRequest from "../api/postRequest";
import { formatVehicleFuelTransmissionLine } from "../utils/vehicleQrLabel";

export default {
  components: {
    "qr-code": VueQrCode,
  },
  data: () => ({
    dialog: false,
    id: null,
    printed: null,
    loading: false,
    vehicle: null,
  }),
  computed: {
    slicedId() {
      if (typeof this.id === "string" && this.id.length) {
        return this.id.slice(-6);
      }
      return "";
    },
  },
  watch: {
    dialog(value) {
      if (!value) {
        this.id = null;
        this.type = null;
        this.printed = null;
        this.loading = false;
        this.vehicle = null;
      }
    },
  },
  methods: {
    open(data) {
      const payload = typeof data === "string" ? { id: data } : data;
      this.dialog = true;
      this.id = payload.id;
      this.type = payload.type;
      this.printed = payload.printed;
      // updated the if condition by inlcuding 'temporary-parts' because we need to show the car data also in 'area pezzi inseriti' qr code print
      if (
        (this.type === "inventory" || this.type === "temporary-parts") &&
        payload.car
      ) {
        this.getCarInfo(payload.car);
      }
    },
    getCarInfo(carId) {
      this.loading = true;
      getRequest("/car/", `id=${carId}`)
        .then((response) => {
          this.vehicle = response.car;
        })
        .catch(() => {
          this.loading = false;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    print() {
      QrCode.toDataURL(this.id, (error, url) => {
        // if (error) {
        //   console.log(error);
        // }
        if (this.vehicle && this.vehicle._id) {
          // Print qr with car details.
          const qrImage = document.createElement("img");
          qrImage.setAttribute("id", "qrImage");
          qrImage.setAttribute("src", url);
          qrImage.style.width = "50px";
          qrImage.style.height = "50px";

          const idDiv = document.createElement("div");
          const slicedId = this.id.slice(this.id.length - 6, this.id.length);
          idDiv.textContent = slicedId;
          idDiv.setAttribute("id", "idText");

          const icon = document.createElement("div");
          icon.innerHTML = `
          <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="20px" height="20px" viewBox="0 0 20 20" version="1.1">
          <g id="surface1">
          <path style=" stroke:none;fill-rule:nonzero;fill:rgb(0%,0%,0%);fill-opacity:1;" d="M 13.644531 13.351562 L 6.355469 13.351562 L 5.710938 14.921875 L 5.597656 15.195312 L 7.003906 15.195312 C 7 15.183594 7 15.171875 7 15.15625 L 7 14.476562 C 7 14.34375 7.105469 14.238281 7.238281 14.238281 C 7.371094 14.238281 7.476562 14.34375 7.476562 14.476562 L 7.476562 15.15625 C 7.476562 15.171875 7.476562 15.183594 7.472656 15.195312 L 9.765625 15.195312 C 9.761719 15.183594 9.761719 15.171875 9.761719 15.15625 L 9.761719 14.476562 C 9.761719 14.34375 9.867188 14.238281 10 14.238281 C 10.132812 14.238281 10.238281 14.34375 10.238281 14.476562 L 10.238281 15.15625 C 10.238281 15.171875 10.238281 15.183594 10.234375 15.195312 L 12.527344 15.195312 C 12.527344 15.183594 12.523438 15.171875 12.523438 15.15625 L 12.523438 14.476562 C 12.523438 14.34375 12.628906 14.238281 12.761719 14.238281 C 12.894531 14.238281 13 14.34375 13 14.476562 L 13 15.15625 C 13 15.171875 13 15.183594 12.996094 15.195312 L 14.402344 15.195312 L 14.289062 14.921875 Z M 13.644531 13.351562 "/>
          <path style=" stroke:none;fill-rule:nonzero;fill:rgb(0%,0%,0%);fill-opacity:1;" d="M 19.859375 7.222656 C 19.8125 7.085938 19.644531 6.976562 19.503906 6.976562 C 18.894531 6.976562 18.285156 6.976562 17.675781 6.976562 C 17.535156 6.976562 17.367188 7.085938 17.320312 7.222656 C 17.253906 7.414062 17.214844 7.574219 17.195312 7.726562 C 16.390625 6.179688 15.5 4.457031 15.5 4.457031 C 15.414062 4.214844 15.199219 4.035156 14.945312 3.988281 C 13.300781 3.691406 11.636719 3.539062 10 3.539062 C 8.367188 3.539062 6.703125 3.691406 5.054688 3.988281 C 4.800781 4.035156 4.585938 4.214844 4.5 4.457031 C 4.5 4.457031 3.609375 6.179688 2.804688 7.726562 C 2.785156 7.574219 2.746094 7.414062 2.679688 7.222656 C 2.632812 7.085938 2.464844 6.976562 2.324219 6.976562 C 1.714844 6.976562 1.105469 6.976562 0.496094 6.976562 C 0.355469 6.976562 0.1875 7.085938 0.140625 7.222656 C -0.046875 7.761719 -0.046875 8.070312 0.140625 8.609375 C 0.1875 8.746094 0.355469 8.855469 0.496094 8.855469 C 1.105469 8.855469 1.710938 8.855469 2.320312 8.855469 C 2.320312 8.878906 2.320312 8.902344 2.324219 8.921875 C 1.9375 9.039062 1.660156 9.398438 1.660156 9.820312 L 1.660156 16.011719 C 1.660156 16.257812 1.859375 16.460938 2.109375 16.460938 L 4.375 16.460938 C 4.625 16.460938 4.828125 16.257812 4.828125 16.011719 L 4.828125 14.921875 L 5.191406 14.921875 L 5.976562 13.023438 C 6.011719 12.933594 6.097656 12.875 6.195312 12.875 L 13.804688 12.875 C 13.902344 12.875 13.988281 12.933594 14.023438 13.023438 L 14.808594 14.921875 L 15.171875 14.921875 L 15.171875 16.011719 C 15.171875 16.257812 15.375 16.460938 15.625 16.460938 L 17.890625 16.460938 C 18.140625 16.460938 18.339844 16.257812 18.339844 16.011719 L 18.339844 9.820312 C 18.339844 9.398438 18.0625 9.039062 17.675781 8.921875 C 17.679688 8.902344 17.679688 8.878906 17.679688 8.855469 C 18.289062 8.855469 18.898438 8.855469 19.503906 8.855469 C 19.644531 8.855469 19.8125 8.746094 19.859375 8.609375 C 20.046875 8.070312 20.046875 7.761719 19.859375 7.222656 Z M 5.503906 4.988281 C 5.503906 4.988281 6.59375 4.710938 10 4.710938 C 13.40625 4.710938 14.496094 4.988281 14.496094 4.988281 L 16.09375 8.855469 L 3.90625 8.855469 Z M 3.519531 11.679688 L 3.519531 10.410156 L 6.269531 10.410156 L 7.089844 11.679688 Z M 16.480469 11.679688 L 12.910156 11.679688 L 13.730469 10.410156 L 16.480469 10.410156 Z M 16.480469 11.679688 "/>
          </g>
          </svg>
        `;
          icon.setAttribute("id", "centerSvg");

          const row1 = document.createElement("div");
          row1.setAttribute("id", "carText");
          row1.textContent = `${this.vehicle.brand.title}`;

          const row2 = document.createElement("div");
          row2.setAttribute("id", "carText");
          const startingDate = this.vehicle.model.startingDate
            ? new Date(this.vehicle.model.startingDate)
            : null;
          const endingDate = this.vehicle.model.endingDate
            ? new Date(this.vehicle.model.endingDate)
            : null;
          row2.textContent = `${this.vehicle.model.description} ${startingDate ? `${startingDate.getMonth() + 1}/${startingDate.getFullYear()}` : ""} - ${endingDate ? `${endingDate.getMonth() + 1}/${endingDate.getFullYear()}` : ""}`;

          const row3 = document.createElement("div");
          row3.setAttribute("id", "carText");
          row3.textContent = this.vehicle.version.description;

          const row4 = document.createElement("div");
          row4.setAttribute("id", "carText");
          row4.textContent = `${this.vehicle.version.engineCode || ""} / ${this.vehicle.version.power.kw} kw / ${this.vehicle.km ? `${this.vehicle.km} km` : ""}`;

          const row5 = document.createElement("div");
          row5.setAttribute("id", "carText");
          row5.textContent = formatVehicleFuelTransmissionLine(
            this.vehicle,
            this.getSupplyLocale(this.vehicle.version.supplyCode),
            this.$t.bind(this),
          );

          const row6 = document.createElement("div");
          row6.setAttribute("id", "carText");
          row6.textContent = `PRA: ${this.vehicle.pra || ""}   ${this.vehicle.registrationYear ? `- ${this.vehicle.registrationYear}` : ""}`;

          const row7 = document.createElement("div");
          const date = this.vehicle.date_created
            ? this.vehicle.date_created.split("T")[0]
            : "";
          row7.setAttribute("id", "carText");
          row7.textContent = `VIN: ${this.vehicle.vin || ""} - DATE:${date}`;

          const table = document.createElement("table");
          table.setAttribute("class", "center");
          const tr = document.createElement("tr");

          const td1 = document.createElement("td");
          const td2 = document.createElement("td");

          td1.appendChild(idDiv);
          td1.appendChild(qrImage);

          td2.appendChild(row1);
          td2.appendChild(row2);
          td2.appendChild(row3);
          td2.appendChild(row4);
          td2.appendChild(row5);
          td2.appendChild(row6);
          td2.appendChild(row7);

          tr.appendChild(td1);
          tr.appendChild(td2);
          table.appendChild(tr);

          const css = [
            `
          @media print {
            @page {
              size: 4cm, 3cm;
              size: landscape;
            }
            body {
              height: 100%;
              width: 100%;
            }
            .hideOnPrint {
              display: none;
            }
            .center {
              margin-left: 10px;
              margin-right: 10px;
            }
            #centerSvg {
              display: block;
              margin: auto;
              text-align:center;
            }
            #qrImage {
              display: block;
              margin: 0 auto;
            }
            #idText {
              font-family: "Roboto";
              font-size: 9px;
              text-align: center;
              font-weight: bold;
              text-transform: uppercase;
            }
            #carText {
              font-family: "Roboto";
              font-size: 7px;
              text-align: left;
              font-weight: bold;
            }
          }
          `,
            "https://fonts.googleapis.com/css?family=Roboto:300,400,500,700|Material+Icons",
          ];

          const d = new Printd();
          d.print(table, css, "", (callback) => {
            const { iframe, launchPrint } = callback;
            const { contentWindow } = iframe;
            contentWindow.addEventListener("afterprint", () => {
              postRequest.object("/print", { type: this.type, id: this.id });
              this.printed = true;
            });
            launchPrint();
          });
        } else {
          // Print only the qr code.
          const qrImage = document.createElement("img");
          qrImage.setAttribute("id", "qrImage");
          qrImage.setAttribute("src", url);
          qrImage.style.width = "100px";
          qrImage.style.height = "100px";

          const idComp = document.createElement("span");
          idComp.textContent = this.id.slice(
            this.id.length - 6,
            this.id.length,
          );
          idComp.setAttribute("id", "idText");

          const urlComp = document.createElement("span");
          urlComp.textContent = "www.lekotech.com";
          urlComp.setAttribute("id", "urlText");

          const content = document.createElement("div");
          content.setAttribute("id", "content");
          content.appendChild(idComp);
          content.appendChild(qrImage);
          content.appendChild(urlComp);

          const css = [
            `
          @media print {
            @page {
              size: 4cm, 3cm;
              size: portrait;
            }
            body {
              height: 100%;
              width: 100%;      
            }
            .hideOnPrint {
              display: none;
            }
            #content {
              padding-top: 5px;
              padding-bottom: 5px;
              display: grid;
            }
            #qrImage {
              margin: 0 auto;
            }
            #idText {
              font-family: "Roboto";
              font-size: 16px;
              text-align: center;
              font-weight: bold;
              text-transform: uppercase;
              margin: 0 auto;
            }
            #urlText {
              font-family: "Roboto";
              font-size: 8px;
              text-align: center;
              font-weight: bold;
              text-transform: lowercase;
              margin: 0 auto;
              padding-top: 10px;
            }
          }
          `,
            "https://fonts.googleapis.com/css?family=Roboto:300,400,500,700|Material+Icons",
          ];

          const d = new Printd();
          d.print(content, css, "", (callback) => {
            const { iframe, launchPrint } = callback;
            const { contentWindow } = iframe;
            contentWindow.addEventListener("afterprint", () => {
              postRequest.object("/print", { type: this.type, id: this.id });
              this.printed = true;
            });
            launchPrint();
          });
        }
      });
    },
    getSupplyLocale(supply) {
      switch (supply) {
        case "B":
          return this.$t("parts.infoCar.supply.petrol");
        case "D":
          return this.$t("parts.infoCar.supply.diesel");
        case "G":
          return this.$t("parts.infoCar.supply.gas");
        default:
          return supply;
      }
    },
  },
};
</script>
